import React, { FocusEvent, useCallback, VFC } from 'react';
import { KeyboardEvent } from '@react-types/shared';

import { TagTextInput } from '../TagTextInput/TagTextInput';
import type { TagTextInputProps } from '../TagTextInput/types';
import { TagEditorProps } from '../types';

export type TagTextInputEditorProps = TagEditorProps<string> & Omit<TagTextInputProps, 'value' | 'onChange'>;

export const TagTextInputEditor: VFC<TagTextInputEditorProps> = function TagTextInputEditor(props) {
    const {
        onAdd,
        onKeyDown,
        inputValue,
        onChange,
        onBlur,
        clearTagIndex,
        isAddOnBlur = true,
        autoFocus = true,
    } = props;

    const addHandler = useCallback(() => {
        const trimmedValue = inputValue?.trim();
        if (trimmedValue && trimmedValue.length !== 0) {
            onAdd?.(trimmedValue);
            onChange('');
        }
    }, [inputValue, onAdd, onChange]);

    const blurHandler = useCallback(
        (event: FocusEvent) => {
            if (isAddOnBlur) {
                addHandler();
            }

            onBlur?.(event);
        },
        [onBlur, addHandler, isAddOnBlur],
    );

    const keyDownHandler = useCallback(
        (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                // Останавливаем всплытие события Escape, чтобы предотвратить например закрытие оверлея
                event.preventDefault();
                event.stopPropagation();
                onChange('');
                clearTagIndex?.();
                return;
            }
            if (event.key === 'Enter') {
                addHandler();
            }

            onKeyDown?.(event);
        },
        [addHandler, onKeyDown, onChange, clearTagIndex],
    );

    return (
        <TagTextInput
            {...props}
            value={inputValue}
            onChange={onChange}
            onKeyDown={keyDownHandler}
            onBlur={blurHandler}
            autoFocus={autoFocus}
        />
    );
};
